import Cookies from 'js-cookie';

export const fetchChangePassword = async (token: string, psw1: string, psw2: string) => {
	try {
		const uid = Cookies.get('u_id') || '';
		const formData = new FormData();

		formData.append('method', 'submit_password');
		formData.append('token', token);
		formData.append('uid', uid);
		formData.append('psw1', psw1);
		formData.append('psw2', psw2);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
	}
};
